export default __webpack_public_path__ + "static/media/scanjupiter.3260df43.svg";